import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, BadgeCheck, CheckCircle } from 'lucide-react';
const HeaderGlpAdv2 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-5977">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-5978"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-5979">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-5980">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-5981">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-5982">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-5983">
          <div className="text-left" data-id="element-5984">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-5985">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-5986">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-5987">
        <div className="max-w-4xl mx-auto" data-id="element-5988">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-5989">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-5990">
            Investigative Report: What Happens To Your Brain's Reward System On
            GLP-1 Drugs—And Why It's Not In The Prescribing Information
          </h1>

          <div className="my-6" data-id="element-5991">
            <img src="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" alt="Person in distress in car" className="w-full h-auto rounded-sm" data-id="element-5992" />
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-5993">
            The Breakthrough Discovery From Uppsala University Research That
            Saved My Sister - And Is Allowing Over 36,700 People To Continue
            Losing Weight With NO Depression, Anxiety, Numbness, Disconnected
            Feeling, Loss Of Motivation, Insomnia, Nightmares or Sense Of Dread
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-3 mb-6 pb-5 border-b border-gray-200" data-id="element-5994">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-5995">
              <img src="https://cdn.magicpatterns.com/uploads/4PvNLd6RsPB1kVDZBzePem/c844778a-6484-4fd0-ade7-865535abf330.png" alt="Journalist" className="w-full h-full object-cover" data-id="element-5996" />
            </div>
            <div className="flex-1" data-id="element-5997">
              <div className="flex items-center gap-1 mb-1" data-id="element-5998">
                <span className="text-sm font-medium text-gray-900" data-id="element-5999">
                  Written by Sarah Mitchell
                </span>
                <BadgeCheck className="h-4 w-4 text-blue-600" data-id="element-6000" />
              </div>
              <div className="text-xs text-gray-600 mb-1" data-id="element-6001">
                Investigative Health Journalist • 17 Yrs Exp
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-6002">
                <div className="flex items-center gap-1" data-id="element-6003">
                  <ClockIcon className="h-3 w-3" data-id="element-6004" />
                  <span data-id="element-6005">14 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-6006">
                  <EyeIcon className="h-3 w-3" data-id="element-6007" />
                  <span data-id="element-6008">31,542 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-6009">
            If you're on Semaglutide or Tirzepatide—and you're noticing things
            like:
          </p>

          <div className="space-y-2 mb-6" data-id="element-6010">
            <div className="flex items-start gap-2" data-id="element-6011">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-6012" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-6013">
                Anxiety that comes from nowhere and won't leave
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-6014">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-6015" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-6016">
                A flat, numb feeling where emotions used to be
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-6017">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-6018" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-6019">
                Vivid nightmares that jolt you awake
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-6020">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-6021" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-6022">
                A sense of dread you can't explain
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-6023">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-6024" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-6025">
                Zero motivation to do things you used to love
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-6026">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-6027" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-6028">
                Feeling disconnected from people close to you
              </p>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-6029">
            ...you're not imagining it. You're not alone.
          </p>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-6030">
            And it's not permanent—if you understand{' '}
            <strong data-id="element-6031">
              what's actually happening inside your body right now
            </strong>
            .
          </p>

          <p className="mb-6 text-base leading-relaxed text-gray-700" data-id="element-6032">
            In my 17 years as an investigative health journalist, I've covered
            dozens of pharmaceutical controversies. But this one hit close to
            home.
          </p>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv2;